import { render, staticRenderFns } from "./StatusUpcoming.vue?vue&type=template&id=5585c959&"
import script from "./StatusUpcoming.vue?vue&type=script&lang=js&"
export * from "./StatusUpcoming.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports